const daysOfWeek = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];

// function isBusinessHours(operating_hours) {
//   const now = new Date();
//   const currentDay = daysOfWeek[now.getDay()];
//   const currentHour = now.getHours();
//   const currentMinute = now.getMinutes();

//   if (operating_hours?.hasOwnProperty(currentDay)) {
//     const { open, close } = operating_hours[currentDay];
//     const [openHour, openMinute] = open.split(":").map(Number);
//     const [closeHour, closeMinute] = close.split(":").map(Number);
//     const afterOpen = currentHour > openHour || (currentHour === openHour && currentMinute >= openMinute);
//     const beforeClose = currentHour < closeHour || (currentHour === closeHour && currentMinute <= closeMinute);
//     return afterOpen && beforeClose;
//   }
//   return false;
// }

/**
 * @param {string} operating_status  - e.g. restaurant?.restaurant_operating_status
 * @param {string} operating_settings - e.g. settings?.restaurant_operating_status (global app setting)
 * @param {object|null} operating_hours - e.g. restaurant?.restaurant_operating_time
 */
// export function isRestaurantOpen(operating_status, operating_settings, operating_hours) {
//   if (operating_status === "open" && operating_settings === "available") {
//     return operating_hours === null || operating_hours === undefined || isBusinessHours(operating_hours);
//   }
//   return false;
// }




function isBusinessHours(
  operating_hours,
  restaurant_time_zone = "UTC+00:00"
) {
  const now = new Date();

  // Get the restaurant's UTC offset
  // Examples:
  // UTC+00:00
  // UTC+01:00
  // UTC-05:00
  const timezoneMatch = restaurant_time_zone.match(
    /^UTC([+-])(\d{2}):(\d{2})$/
  );

  if (!timezoneMatch) {
    console.error(
      "Invalid restaurant timezone:",
      restaurant_time_zone
    );
    return false;
  }

  const [, sign, hours, minutes] = timezoneMatch;

  const offsetMinutes =
    (Number(hours) * 60 + Number(minutes)) *
    (sign === "+" ? 1 : -1);

  // Convert current time to UTC first
  const utcTime =
    now.getTime() + now.getTimezoneOffset() * 60 * 1000;

  // Apply restaurant's timezone offset
  const restaurantTime = new Date(
    utcTime + offsetMinutes * 60 * 1000
  );

  const currentDay = daysOfWeek[restaurantTime.getUTCDay()];
  const currentHour = restaurantTime.getUTCHours();
  const currentMinute = restaurantTime.getUTCMinutes();

  if (operating_hours?.hasOwnProperty(currentDay)) {
    const { open, close } = operating_hours[currentDay];

    if (!open || !close) {
      return false;
    }

    const [openHour, openMinute] = open.split(":").map(Number);
    const [closeHour, closeMinute] = close.split(":").map(Number);

    const currentTimeInMinutes =
      currentHour * 60 + currentMinute;

    const openTimeInMinutes =
      openHour * 60 + openMinute;

    const closeTimeInMinutes =
      closeHour * 60 + closeMinute;

    // Normal hours, e.g. 09:00 - 22:00
    if (closeTimeInMinutes >= openTimeInMinutes) {
      return (
        currentTimeInMinutes >= openTimeInMinutes &&
        currentTimeInMinutes <= closeTimeInMinutes
      );
    }

    // Overnight hours, e.g. 18:00 - 02:00
    return (
      currentTimeInMinutes >= openTimeInMinutes ||
      currentTimeInMinutes <= closeTimeInMinutes
    );
  }

  return false;
}

/**
 * @param {string} operating_status
 * @param {string} operating_settings
 * @param {object|null} operating_hours
 * @param {string} restaurant_time_zone - e.g. "UTC+01:00"
 */
export function isRestaurantOpen(
  operating_status,
  operating_settings,
  operating_hours,
  restaurant_time_zone = "UTC+00:00"
) {
  if (
    operating_status === "open" &&
    operating_settings === "available"
  ) {
    return (
      operating_hours === null ||
      operating_hours === undefined ||
      isBusinessHours(
        operating_hours,
        restaurant_time_zone
      )
    );
  }

  return false;
}

